"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubSource = exports.ECancelReasons = void 0;
// These options are only available for feedback in stripe, we cannot modify them
var ECancelReasons;
(function (ECancelReasons) {
    ECancelReasons["CUSTOMER_SERVICE"] = "customer_service";
    ECancelReasons["LOW_QUALITY"] = "low_quality";
    ECancelReasons["MISSING_FEATURES"] = "missing_features";
    ECancelReasons["OTHER"] = "other";
    ECancelReasons["SWITCHED_SERVICE"] = "switched_service";
    ECancelReasons["TOO_COMPLEX"] = "too_complex";
    ECancelReasons["TOO_EXPENSIVE"] = "too_expensive";
    ECancelReasons["UNUSED"] = "unused";
})(ECancelReasons = exports.ECancelReasons || (exports.ECancelReasons = {}));
var ESubSource;
(function (ESubSource) {
    ESubSource[ESubSource["ALL"] = 0] = "ALL";
    ESubSource[ESubSource["STRIPE"] = 1] = "STRIPE";
    ESubSource[ESubSource["REVENUE_CAT"] = 2] = "REVENUE_CAT";
})(ESubSource = exports.ESubSource || (exports.ESubSource = {}));
